// autogenerated by channel_search/generate.py -- do not edit
import { SubscriptionAck } from "@skydio/pbtypes/pbtypes/infrastructure/skybus_tunnel/tunnel_pb";
export { SubscriptionAck };

export const WEBRTC_SUBSCRIPTION_ACK_PB = {
  channel: "WEBRTC_SUBSCRIPTION_ACK_PB",
  channelId: 12392,
  type: SubscriptionAck.deserializeBinary
};
